<template>
  <!-- v-if="theme" -->
  <div class="main" v-if="userInfo.user">
    <div class="wrapper">
      <div class="wrapper-header">
        <img class="layout-logo" :src="solutionEntrance" :alt="systemTitle" />
        <span class="layout-logo-subTit">|&nbsp;{{ systemTitle }}</span>
        <div class="header-avator-con flex flex-reverse flex-align-center">
          <div class="user-dropdown-menu-con">
            <Row type="flex" justify="end" align="middle" class="user-dropdown-innercon">
              <Dropdown
                transfer
                trigger="click"
                style="height: 20px; line-height: 20px"
                @on-click="handleClickUserDropdown"
              >
                <a href="javascript:void(0)">
                  <span class="main-user-name" v-if="userInfo.user">{{ userInfo.user.name }}</span>
                  <Icon type="md-arrow-dropdown"></Icon>
                </a>
                <DropdownMenu slot="list" v-if="userInfo.user">
                  <DropdownItem name="profile">基本信息</DropdownItem>
                  <DropdownItem name="password">修改密码</DropdownItem>
                  <DropdownItem name="loginout" divided>退出登录</DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <Avatar
                :src="userInfo.portrait"
                v-if="userInfo.portrait != ''"
                style="margin-left: 10px"
              ></Avatar>
              <div v-else class="icon-avatar">
                <Icon type="ios-person" size="22"></Icon>
              </div>
            </Row>
          </div>
          <div class="margin-right-20">
            <popTipOfMessage
              v-if="userInfo.user"
              :isPanguPopTipShow="true"
              :urlQueryNotReadMessage="urlQueryNotReadMessage"
              :urlPollMessage="urlPollMessage"
              :urlReadAll="urlReadAll"
              :urlRead="urlRead"
            ></popTipOfMessage>
          </div>
          <!-- <message-tip class="pad-0" v-model="mesCount"></message-tip>
            <chat-tip class="pad-0" v-model="chatCount"></chat-tip>-->
          <downloadApp class="down-App margin-right-20" v-if="system !== 'reunion'"></downloadApp>
          <span class="margin-right-20" v-if="system !== 'reunion' && curDate != ''">
            今天是:
            <i class="form-right">{{ curDate }}</i>
          </span>
        </div>
        <!-- </Menu> -->
      </div>
      <div class="wrapper-container">
        <div class="wrapper-container-left">
          <shrinkable-menu
            :shrink="shrink"
            theme="dark"
            :before-push="beforePush"
            :open-names="openedSubmenuArr"
            :menu-list="menuList"
          ></shrinkable-menu>
        </div>
        <div class="wrapper-container-content">
          <router-view v-if="userInfo.user"></router-view>
        </div>
        <!-- <div class="wrapper-container-right">
          <Affix :offset-top="60">
            <systemEntrance v-if="userInfo.user"></systemEntrance>
          </Affix>
        </div> -->
      </div>
    </div>
    <div class="footer">
      <copyright :copyright="copyright" :style="{ color: '#999999' }"></copyright>
    </div>
    <password
      :modal="componentItem.show"
      :modalInfo="componentItem.info"
      v-if="componentItem.show"
      @visible-change="visibleChange"
    ></password>
  </div>
</template>
<script>
import shrinkableMenu from './main-components/shrinkable-menu/shrinkable-menu.vue'
import messageTip from './main-components/message-tip.vue'
import chatTip from './main-components/chat-tip.vue'
import systemEntrance from './main-components/systemEntrance.vue'
import Cookies from 'js-cookie'
import util from '@/libs/util.js'

import password from '@/views/security/password.vue'
export default {
  components: {
    shrinkableMenu,
    messageTip,
    chatTip,
    systemEntrance,
    password,
  },
  data() {
    return {
      shrink: false,
      curDate: '',
      curTabName: '',
      unreadNews: [], // 未读消息
      allTotal: 0, // 未读消息条数
      noNews: '当前暂无消息',
      openedSubmenuArr: this.$store.state.app.openedSubmenuArr,
      isRouterAlive: true, //点击刷新：true显示组件，false卸载组件
      componentItem: {
        name: '修改密码',
        params: '',
        show: false,
        info: {
          label: '登录密码',
          desc: '安全性高的密码可以使账号更安全。建议您定期更换密码。',
          key: 'password',
          keyname: '修改密码',
          icon: 'ios-unlocked-outline',
          show: 'visible',
        },
      },
      urlPollMessage: '/rest/ezcomp/message/nextMessage',
      urlQueryNotReadMessage: '/rest/ezcomp/message/queryPaged',
      urlReadAll: '/rest/ezcomp/message/readAll',
      urlRead: '/rest/ezcomp/message/read',
      theme: false,
    }
  },
  computed: {
    system() {
      const systemObj = this.$store.state.user.solutionInfo.theme
      console.info(systemObj, 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx')
      return systemObj
    },
    userInfo() {
      console.log('this.$store.state.currentToken', this.$store.state.user.currentToken)
      if (this.$store.state.user.currentToken) {
        return this.$store.state.user.currentToken
      }
      return {}
    },
    // 个人中心左上角的logo是单独的
    solutionEntrance() {
      if (this.$store.state.user.solutionInfo && this.$store.state.user.solutionInfo.entrance) {
        return this.$store.state.user.solutionInfo.entrance
      } else if (this.$store.state.user.solutionInfo.banner) {
        return this.$store.state.user.solutionInfo.banner
      } else {
        return 'static/images/logo-pg.png'
      }
    },
    systemTitle() {
      return this.$store.state.user.defaultTitle
    },
    copyright() {
      if (this.$store.state.user.solutionInfo) {
        let str = `${this.$store.state.user.solutionInfo.certificate}&nbsp;版本${this.$store.state.user.solutionInfo.versionText}<br>${this.$store.state.user.solutionInfo.copyright}<br>`
        return str
      }
    },
    menuList() {
      return this.$store.state.app.menuList
    },
    mesCount() {
      return this.$store.state.app.messageCount
    },
    chatCount() {
      return this.$store.state.app.chatCount
    },
    cachePage() {
      return this.$store.state.app.cachePage
    },
  },
  methods: {
    // // 获取未读消息通知
    // unreadMes() {
    //     this.$axios.get('/rest/main/message/queryNotReadMessage', {params: {method: "EVENT_METHOD_10"}})
    //         .then((res) => {
    //             let respons = res.data.data;
    //                 if (res.data.code === 200) {
    //                 this.unreadNews = respons ? respons : [];
    //                 this.allTotal = this.unreadNews.length;
    //             }

    //         })
    //         .catch((error) => {
    //                 console.log(error)
    //             })
    // },
    // // 查看全部未读消息
    // showAll() {
    //     this.$router.push('/messageEnter/messageEnter_home');
    // },
    // // 全部标为已读
    // removeAll() {
    //     this.$axios.get('/rest/main/message/readAll', {params: {method: "EVENT_METHOD_10"}}).then((res) => {
    //             if (res.data.code === 200) {
    //                 this.unreadMes();
    //             }
    //         })
    // },
    visibleChange() {
      this.componentItem.show = false
    },
    refrash(name) {
      /**
       * 点击tab刷新当前组件
       * isRouterAlive：true显示组件，false卸载组件
       * closePage：(参考app.js)将当前组件名称移出存储区
       * addCachePage：(参考app.js)页面渲染完毕后，将当前组件名称加入存储区
       */
      this.isRouterAlive = false
      this.curTabName = name
      this.$store.commit('closePage', name)
      this.$nextTick(() => {
        this.isRouterAlive = true
        this.$store.commit('addCachePage', name)
      })
    },
    // hasGetSystemInfo(system){
    //     this.theme = false;
    //     // import 原则，地址尽量静态化，变量作用域最小
    //     if(system){
    //         // 由于灵科还没有设计样式，因此目前做特殊处理，灵科与优联显示同一样式
    //         if(system == 'link') {
    //             import(`../themes/link.less`).then(()=>{
    //                 this.theme = true;
    //             });
    //         }else if(system == 'union'){
    //             import(`../themes/union.less`).then(()=>{
    //                 this.theme = true;
    //             });
    //         }else if(system == 'jd'){
    //             import(`../themes/jd.less`).then(()=>{
    //                 this.theme = true;
    //             });
    //         }else if(system == 'reunion') {
    //             import(`../themes/reunion.less`).then(()=>{
    //                 this.theme = true;
    //             });
    //         }else{
    //             import(`../themes/union.less`).then(()=>{
    //                 this.theme = true;
    //             });
    //         }
    //     }
    // },
    async getMenuList() {
      const res = await this.$axios.get('rest/main/index/getNavigation?lead=0')
      if (res?.data?.code === 200) {
        const resData = res.data.data ?? []
        return resData.map((im) => ({
          path: im.operation,
          name: im.component,
          title: im.name,
          icon: im.icon,
        }))
      }
      return []
    },
    async init() {
      let pathArr = util.setCurrentPath(this, this.$route.name)
      const nowMenuList = await this.getMenuList()
      this.$store.commit('updateMenulist', nowMenuList)
      if (pathArr.length >= 2) {
        this.$store.commit('addOpenSubmenu', pathArr[1].name)
      }
      this.userName = Cookies.get('user')
      let messageCount = 3
      this.messageCount = messageCount.toString()
      this.$store.commit('setMessageCount', 3)
      this.getCurrentDate()

      // 获取未读消息通知
      // this.unreadMes();
    },
    handleClickUserDropdown(name) {
      if (name === 'profile') {
        // 防止重复访问当前路由
        if (this.$route.name === 'profile_home') {
          return false
        }
        util.openNewPage(this, 'profile_home')
        this.$router.push({
          name: 'profile_home',
        })
      } else if (name === 'loginout') {
        // 退出登录
        this.$root.logout()
      } else if (name === 'password') {
        // 退出登录
        this.componentItem.show = true
      }
    },
    getCurrentDate() {
      let that = this
      this.$axios
        .get('/rest/main/index/getCurrentDate')
        .then((res) => {
          that.curDate = res.data.data
        })
        .catch((res) => {
          return
        })
    },
    checkTag(name) {
      let openpageHasTag = this.pageTagsList.some((item) => {
        if (item.name === name) {
          return true
        }
      })
      if (!openpageHasTag) {
        //  解决关闭当前标签后再点击回退按钮会退到当前页时没有标签的问题
        util.openNewPage(this, name, this.$route.params || {}, this.$route.query || {})
      }
    },
    handleSubmenuChange(val) {
      // console.log(val)
    },
    beforePush(name) {
      // if (name === 'accesstest_index') {
      //     return false;
      // } else {
      //     return true;
      // }
      return true
    },
    fullscreenChange(isFullScreen) {
      // console.log(isFullScreen);
    },
    goDetail(id, pageNo, pageSize) {
      this.$router.push({
        path: '/noticeDetail',
        query: { id, pageNo, pageSize },
      })
    },
    // toISCCMessageDetail(unreadnew) {
    //     systemUtil(this,this.$store.state.user.currentToken.id,
    //         unreadnew.organization.code,
    //         unreadnew.system.code,
    //         "/"+unreadnew.system.code.toLowerCase(),
    //         this.GLOBAL.domain,
    //         (url) => {
    //             let path = unreadnew.process.web.path.replace(":id",unreadnew.parameter.id);
    //             path = path.replace(":complete",unreadnew.complete);
    //             var win1=window.open(url + "#" + path);
    //             if(!win1||!win1.location){
    //                 this.$Message.error("被浏览器拦截了，请设置浏览器允许弹出窗口！");
    //             }
    //         }
    //     );
    // }
  },
  // watch: {
  //   // '$route' (to) {
  //   //     this.$store.commit('setCurrentPageName', to.name);
  //   //     let pathArr = util.setCurrentPath(this, to.name);
  //   //     if (pathArr.length > 2) {
  //   //         this.$store.commit('addOpenSubmenu', pathArr[1].name);
  //   //     }
  //   //     // this.checkTag(to.name);
  //   //     localStorage.currentPageName = to.name;
  //   // },
  //   // lang() {
  //   //     util.setCurrentPath(this, this.$route.name); // 在切换语言时用于刷新面包屑
  //   // }
  //   system: {
  //       handler:function(val) {
  //           console.info(val,'jjjjjjjjjjjjjjjjjjjjj')
  //           this.hasGetSystemInfo(val);
  //       },
  //       immediate: true
  //   }
  // },
  mounted() {
    let that = this
    //单独解决passport的401的问题
    //
    //
    //
    console.log('this.$store.state.currentToken', this.$store.state.currentToken)
    // this.$SsoRequest.gotoSSOLogin = function() {
    //   that.$store.commit("logout", that);
    //   that.$store.commit("clearOpenedSubmenu");
    //   that.$router.push({ name: "login", query: that.$router.query });
    // };

    //设置浏览器title
    this.$store.dispatch('setSolution', this)
  },
  beforeCreated() {},
  created() {
    this.$SsoRequest.checkAuth(this, (res) => {
      console.log('checkAuth', res)
      this.init()
    })
    // 显示打开的页面的列表
    this.$store.commit('setOpenedList')
  },
}
</script>
